import React, { Component } from 'react';
import { Col, Container, Row, Card, CardBody, Button } from 'reactstrap';
import { connect } from 'react-redux';

class Footer extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="footer">
        <Container>
          <Row>
            <Col md={7} lg={7}>
              <span className="copyright-text">Copyright © 2019 FintruX. All Rights Reserved.</span>
            </Col>
            <Col md={5} lg={5}>
              <ul className="footer-links">
                <li><a href="https://www.fintrux.com/home/doc/PrivacyPolicy.pdf" target="_blank">Privacy Policy</a></li>
                <li><a href="https://www.fintrux.com/home/doc/TermsOfUse.pdf" target="_blank">Terms &amp; Conditions</a></li>
                <li><a href="https://www.fintrux.com/home/doc/CookiePolicy.pdf" target="_blank">Cookie Policy</a></li>
              </ul>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

export default connect()(Footer);


// WEBPACK FOOTER //
// ./src/pages/_layout/Footer.js